import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import { NavIcon } from './navIcons';
import { NAV_SECTIONS, type NavItem } from './navigation';

function NavItemLink({ item, onNavigate }: { item: NavItem; onNavigate?: () => void }) {
  const { t } = useTranslation('layout');
  return (
    <NavLink
      to={item.to}
      {...(item.end ? { end: true } : {})}
      onClick={onNavigate}
      className={({ isActive }) =>
        [
          'gs-nav-link flex h-[38px] w-full items-center gap-3 rounded-[10px] px-3 text-start text-[14.5px] no-underline transition-[color,background-color] duration-[120ms]',
          isActive ? 'gs-nav-link-active' : '',
        ].join(' ')
      }
    >
      {({ isActive }) => (
        <>
          <span
            className="grid h-[19px] w-[19px] shrink-0 place-items-center"
            style={{ color: isActive ? 'var(--gs-accent)' : 'var(--gs-muted)' }}
          >
            <NavIcon id={item.icon} active={isActive} />
          </span>
          {t(`nav.items.${item.label}`)}
        </>
      )}
    </NavLink>
  );
}

/**
 * Sectioned sidebar nav — Ghost Screen - Home.dc.html.
 */
export function SidebarNav({ onNavigate }: { onNavigate?: () => void }) {
  const { t } = useTranslation('layout');
  return (
    <nav
      className="flex flex-1 flex-col gap-[18px] overflow-y-auto px-3.5 pb-3.5 pt-1"
      aria-label={t('nav.primary')}
    >
      {NAV_SECTIONS.map((section) => (
        <div key={section.title} className="flex flex-col gap-0.5">
          <span
            className="px-3 pb-1.5 pt-1.5 text-[11px] font-bold uppercase tracking-[0.12em]"
            style={{ color: 'var(--gs-muted)' }}
          >
            {t(`nav.sections.${section.title}`)}
          </span>
          {section.items.map((item) => (
            <NavItemLink
              key={item.to}
              item={item}
              {...(onNavigate ? { onNavigate } : {})}
            />
          ))}
        </div>
      ))}
    </nav>
  );
}
